// The EUSU Non-Selling Stock guide (60_EusuStock.jsx · ModuleHelp, Max 01/11).
const en = {
  weekT: 'Pick a week',
  weekB: 'Every uploaded stock list is stored as a week. Choose the week the dashboard below should show.',
  uploadT: 'Upload the warehouse file',
  uploadB: 'Choose the warehouse inventory .xls to add a week. You see what it holds before it is saved; items it could not place are listed above the tabs for you to fix.',
  tabsT: 'Three pages',
  tabsB: 'Overview, By root cause, and WoW change. The same week is shown three ways.',
  tilesT: 'The week in four numbers',
  tilesB: 'Quantity, amount in USD, SKU count and number of root causes, with the change from the previous week.',
  chartsT: 'Where it sits',
  chartsB: 'Quantity and amount split by root cause, and how both moved over the recent weeks. The table under them sums up each cause.',
};
const ko = {
  weekT: '주차 선택',
  weekB: '업로드한 재고 리스트는 주 단위로 저장됩니다. 아래 대시보드에 보여줄 주를 고르세요.',
  uploadT: '창고 파일 업로드',
  uploadB: '창고 재고 .xls 파일을 선택하면 한 주가 추가됩니다. 저장 전에 내용을 미리 볼 수 있고, 분류하지 못한 품목은 탭 위에 목록으로 나와 직접 고칠 수 있습니다.',
  tabsT: '세 개의 화면',
  tabsB: 'Overview, 원인별, 전주 대비 변화입니다. 같은 주를 세 가지 방식으로 보여줍니다.',
  tilesT: '네 개 숫자로 보는 한 주',
  tilesB: '수량, USD 금액, SKU 수, 원인 수이며 전주 대비 증감도 보여줍니다.',
  chartsT: '분포 보기',
  chartsB: '원인별 수량과 금액의 비중, 최근 몇 주 동안의 추이입니다. 아래 표는 원인별로 합계를 보여줍니다.',
};
const vi = {
  weekT: 'Chọn tuần',
  weekB: 'Mỗi danh sách tồn kho đã tải lên được lưu thành một tuần. Chọn tuần mà dashboard bên dưới sẽ hiển thị.',
  uploadT: 'Tải file kho lên',
  uploadB: 'Chọn file .xls tồn kho của kho để thêm một tuần. Bạn xem được nội dung trước khi lưu; mã hàng không xếp được sẽ nằm trên các tab để bạn sửa.',
  tabsT: 'Ba trang',
  tabsB: 'Overview, theo nguyên nhân gốc và thay đổi so với tuần trước. Cùng một tuần nhưng nhìn theo ba cách.',
  tilesT: 'Một tuần qua bốn con số',
  tilesB: 'Số lượng, giá trị USD, số SKU và số nguyên nhân, kèm chênh lệch so với tuần trước.',
  chartsT: 'Hàng nằm ở đâu',
  chartsB: 'Số lượng và giá trị chia theo nguyên nhân gốc, cùng diễn biến của cả hai qua các tuần gần đây. Bảng bên dưới tổng hợp từng nguyên nhân.',
};
const zh = {
  weekT: '选择周',
  weekB: '每次上传的库存清单都会保存为一周。请选择下方看板要显示的周。',
  uploadT: '上传仓库文件',
  uploadB: '选择仓库库存 .xls 文件即可新增一周。保存前可以先查看内容；无法归类的物品会列在标签页上方，供你修正。',
  tabsT: '三个页面',
  tabsB: 'Overview、按根本原因、环比变化。同一周用三种方式呈现。',
  tilesT: '用四个数字看一周',
  tilesB: '数量、USD 金额、SKU 数量和根本原因数，并显示与上周的变化。',
  chartsT: '分布情况',
  chartsB: '按根本原因拆分的数量和金额，以及两者近几周的走势。下方表格汇总每个原因。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "weekT": "Choisir une semaine",
  "weekB": "Chaque liste de stock importée est conservée comme une semaine. Choisissez la semaine que le tableau de bord ci-dessous doit afficher.",
  "uploadT": "Importer le fichier de l'entrepôt",
  "uploadB": "Choisissez le fichier .xls d'inventaire de l'entrepôt pour ajouter une semaine. Vous voyez son contenu avant l'enregistrement ; les éléments qui n'ont pu être placés sont listés au-dessus des onglets pour que vous les corrigiez.",
  "tabsT": "Trois pages",
  "tabsB": "Vue d'ensemble, Par cause racine et Évolution WoW. La même semaine est présentée de trois façons.",
  "tilesT": "La semaine en quatre chiffres",
  "tilesB": "Quantité, montant en USD, nombre de SKU et nombre de causes racines, avec l'évolution par rapport à la semaine précédente.",
  "chartsT": "Où il se situe",
  "chartsB": "Quantité et montant répartis par cause racine, et leur évolution au fil des dernières semaines. Le tableau en dessous résume chaque cause."
};
const ja = {
  "weekT": "週を選択",
  "weekB": "アップロードされた在庫リストは、それぞれ1週分として保存されます。下のダッシュボードに表示する週を選んでください。",
  "uploadT": "倉庫ファイルをアップロード",
  "uploadB": "倉庫在庫の .xls ファイルを選択して1週分を追加します。保存前に内容を確認でき、振り分けられなかった項目はタブの上に一覧表示されるので修正してください。",
  "tabsT": "3つのページ",
  "tabsB": "「概要」「根本原因別」「WoW 変化」です。同じ週を3通りで表示します。",
  "tilesT": "4つの数字で見る1週間",
  "tilesB": "数量、USD 建ての金額、SKU 数、根本原因の数と、前週からの変化を表示します。",
  "chartsT": "内訳",
  "chartsB": "数量と金額を根本原因別に分け、直近数週間の推移を表示します。下の表は各原因の合計です。"
};

const dictionary = { ns: 'tourEusu', en, ko, vi, zh, fr, ja };
export default dictionary;
